import { formatISOBasic } from '../date/DateFormatter';
import ajax from '../../../utils/ajax';

let additionalApiData = {};

function setAdditionalApiData(data) {
  additionalApiData = data;
}

async function post(data_) {
  const data = { ...additionalApiData, ...data_ };

  data.startDate = formatISOBasic(data.startDate);
  data.endDate = formatISOBasic(data.endDate);

  const response = await ajax.post('/api/products/productionseasons', data);

  return {
    productions: response.productions,
    ga4DatalayerItems: response.ga4DatalayerItems,
    requestData: data,
  };
}

export default {
  setAdditionalApiData,
  post,
};
